import * as querystring from 'querystring';

const removeBlankKeys = (obj) =>
  Object.entries(obj)
    .filter(([_key, value]) => Boolean(value))
    .reduce((obj, [key, value]) => {
      return { ...obj, [key]: value };
    }, {});

export default {
  parse: (queryString) => {
    if (!queryString) return {};
    const parsed = querystring.parse(queryString.substring(1));
    // Support legacy JSON querystrings
    const JSONparsed = Object.entries(parsed).reduce(
      (JSONparsed, [key, value]) => {
        try {
          const parsed = JSON.parse(value);
          return { ...JSONparsed, [key]: parsed };
        } catch (e) {
          return { ...JSONparsed, [key]: value };
        }
      },
      {}
    );
    return JSONparsed;
  },
  stringify: (object) => {
    if (!object) return '';
    return '?' + querystring.stringify(removeBlankKeys(object));
  },
};
